import { Label, Row,Col,ReactSelectBox, PrimaryButton, OutlineButton } from 'client/CommonComponents';
import { CONSTANTS } from '../../../../../utils/constants'
import Development from './Development';
import Snow from './Snow';
import Trailer from './Trailer';
import TreeCare from './TreeCare';
import UtilityVehicle from './UtilityVehicle';
import StandarizedEquipment from './StandarizedEquipment';
import Mower from './Mower';

const ManagedEquipment = (props?: any) => {
  const selectedEquipment = props?.selectedEquipmentType;
  const handleEquipmentTypeChanges = props?.handleEquipmentTypeChanges;
  const equipmentDropdownList = props?.equipmentDropdownList;
  const managedEquipRef = props?.managedEquipRef;
  const searchOnClick= props?.searchOnClick;
  const managedEquipmentValidation = props?.managedEquipmentValidation;
  const resetOnClick = props?.resetOnClick

  const selectedEquipmentType = () => {
    if (selectedEquipment?.label === CONSTANTS.CONSTRUCTION_EQUIPMENT) {
      return <Development managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.SNOW) {
      return <Snow managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.TRAILER) {
      return <Trailer managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.TREE_CARE) {
      return <TreeCare managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.UTILITY_VEHICLE) {
      return <UtilityVehicle managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.STANDARIZED_EQUIPMENT) {
      return <StandarizedEquipment managedEquipRef={managedEquipRef}/>
    }
    else if (selectedEquipment?.label === CONSTANTS.MOWER) {
      return <Mower managedMowerRef={managedEquipRef}/>
    }
  }

    return (<div className='managed-equipment p-3'>
    <Row>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label required data-attribute="ManagedEquipment_Default_Label">Equipment Type</Label>
        <ReactSelectBox
          options={equipmentDropdownList}
          onChange={(item: any, e: any) => handleEquipmentTypeChanges(e, item,'equipmentType')}
          value={selectedEquipment}
          selectRef={(element:any)=>managedEquipRef.current[0] = element}
         data-attribute="ManagedEquipment_Default_SearchSelectBox" />
        {managedEquipmentValidation.EquipmentTypeError.length > 0 ? <p className='validMessage'>{managedEquipmentValidation.EquipmentTypeError}</p> : null}
      </Col>
      {selectedEquipmentType()}  
    </Row>
    <Row className='mb-1'>
      <Col xs={12} sm={12} md={12} lg={12} className='mt-0'>
        <div className='pull-right'>
            <OutlineButton text='Reset' onClick={resetOnClick} data-attribute="ManagedEquipment_Default_Button" />
            <PrimaryButton text='Search' onClick={searchOnClick} btnRef={(element:any)=>managedEquipRef.current[9] = element} data-attribute="ManagedEquipment_Default_Button_2" />
        </div>
      </Col>
    </Row>
    </div>)
}

export default ManagedEquipment;
